import { render, staticRenderFns } from "./TransactionDetailsModal.vue?vue&type=template&id=9484b79e&"
import script from "./TransactionDetailsModal.vue?vue&type=script&lang=js&"
export * from "./TransactionDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports